;(function(global, $) {
  var defaults = {
    url: '',
    type: 'GET',
    dataType: 'json',
    contentType: "application/json;charset=utf-8",
    data: {}
  }

  /**
   * fetch接口数据
   * @param {object} options 选项
   * @param {function} callback 回调方法
   * @param {boolean | object} extra 是否携带token 或 其他选项
   */
  function fetch(options, callback, extra) {
    var token = CookieUtil.get('hwUserToken')
    var isAuth = (extra === false || (isType(extra) === 'object' && extra.isAuth === false)) ? false : true
    if (isAuth) {
      defaults.beforeSend = function (req) {
        if (token) {
          req.setRequestHeader("Authorization", token)
        }
      }
    }
    var opts = $.extend(defaults, options)
    // opts.data = opts.type === 'POST' ? JSON.stringify(opts.data) : opts.data
    $.ajax(opts)
    .done(function(res) {
      callback([null, res])
    })
    .fail(function(error) {
      callback([error])
    })
  }

  global['Fetch'] = fetch
}(window, window.jQuery))
